import React, {
  Component
} from 'react';

class EmptyStateGraphic extends Component {
  constructor(props){
    super(props);
  }

  getTitle(){
    return this.props.title;
  }

  render(){
    return (
      <div className="empty-state" style={ this.props.style || {} }>
        <div className="title"> {this.getTitle()} </div>
      </div>
    )
  }
}

export default EmptyStateGraphic;


// WEBPACK FOOTER //
// ./src/components/EmptyStateGraphic/EmptyStateGraphic.jsx